const initState = {topic: ""}

const topicReducer = (state = initState, action) => {
  switch (action.type) {
    case 'CHANGE_TOPIC':
      return {...state, topic: action.topic};
    case 'CHANGE_TOPIC_ERROR':
      return state;
    default:
      return state;
  }
};

export default topicReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/topicReducer.js